import { useRef, useState, useCallback, useEffect } from 'react'

export const useAudio = (source?: string) => {
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const [isPlaying, setPlaying] = useState(false)
  const [isFirstPlay, setFirstPlay] = useState(true)
  const [progress, setProgress] = useState(0)

  const play = () => {
    if (!isPlaying) {
      if (source) {
        setPlaying(true)
        const audio = new Audio(source)
        audioRef.current = audio

        audio.play()
        audio.ontimeupdate = () => {
          setProgress((audio.currentTime / audio.duration) * 100)
        }
        audio.onended = () => {
          setPlaying(false)
          audio.currentTime = 0
        }
      }
    }
  }

  const stop = useCallback(() => {
    if (isPlaying) {
      setPlaying(false)
      setFirstPlay(false)
      if (audioRef.current) {
        audioRef.current.pause()
        audioRef.current.currentTime = 0
      }
    }
  }, [isPlaying])

  const togglePlay = () => {
    if (isPlaying) {
      stop()
    } else {
      play()
    }
  }

  useEffect(
    () => () => {
      if (isPlaying) {
        stop()
      }
    },
    [stop, isPlaying],
  )

  return {
    isPlaying,
    isFirstPlay,
    progress,
    play,
    stop,
    togglePlay,
  }
}
